import classnames from 'classnames';
import { ArrowLeftOutlined } from 'iglooicon';
import { useIntl } from 'react-intl';
import useMobile from '@/hooks/useMobile';
import './back-button.less';
import { Typography } from 'iglooform';

interface IBackButton {
  handleClick: () => void;
}

const BackButton = ({ handleClick }: IBackButton) => {
  const { formatMessage } = useIntl();
  const isMobile = useMobile();
  return (
    <a
      className={classnames([
        'back-title',
        {
          'is-mobile': isMobile,
        },
      ])}
      onClick={handleClick}
    >
      <ArrowLeftOutlined
        style={{
          display: 'block',
          float: 'left',
          color: '#5858FF',
          fontSize: '24px',
          marginRight: '4px',
          marginLeft: '-6px',
        }}
      />
      <Typography
        level="body1"
        style={{
          display: 'block',
          float: 'left',
          color: '#5858FF',
          fontWeight: 700,
        }}
      >
        {formatMessage({ id: 'Back' })}
      </Typography>
    </a>
  );
};

export { BackButton };
